export interface AdvisoryMessageBanner {
  advisoryLabel: string;
  advisoryMessage: string;
  isInterline: boolean;
  interlineMessage: string;
  interlineFlightNo: string;
}
